import { IonContent, IonPage, IonButton, IonHeader, IonToolbar, IonToast, IonLoading,
  IonIcon, IonText, IonRow, IonGrid, useIonViewDidEnter} from '@ionic/react';

import React, { useState, useEffect } from 'react';
import { RouteComponentProps} from "react-router-dom";
import { MapGroup } from "../../components/Explore/Map-groups";
import {get} from '../../services/storage.service';

import { useHistory } from "react-router-dom";
import { remove } from '../../services/storage.service';
import FooterComponent from "../../components/FooterComponent";
import LoginCheck from "../../components/LoginCheck";
import { logOutOutline, chevronBackOutline } from 'ionicons/icons';

import './ViewExploration.css';

export interface Photo {
  filepath: string;
  webviewPath?: string;
}

interface ResetProps
    extends RouteComponentProps<{
        color: string,
        name: string;
    }> { }

    interface LocationError {
      showError: boolean;
      message?: string;
  }
const ViewExploration: React.FC<ResetProps> = ({ match }) => {

const projtitle = match.params.name;


  const history = useHistory();
  function logOut(){
    remove('cred');
    history.replace('/home');
  }
  var uniqueID = Math.random().toString(36).substr(2, 9);
  const markersDefault = [
      {pos: [43.073051,-89.401230], title: 'Hello World', description: 'popup description', id: uniqueID, filepath: "", webview: "", color: "blue"}
  ];

  //end markers drag
  var location: [number,number] = [
    43.073051, -89.401230
  ]

  const [group, setGroup] = useState<string>('Group 1');
  const [error, setError] = useState<LocationError>({ showError: false });
  const [loading, setLoading] = useState<boolean>(false);
  const [markers, setMarkers] = useState<any>(markersDefault);
  const [mapCenter, setCenter] = useState<any>(location);
  const [myMarkers, setMyMarkers] = useState<any>([]);
  const [myMarkers2, setMyMarkers2] = useState<any>([]);
  const [myMarkers3, setMyMarkers3] = useState<any>([]);

  const [color1,setColor1] = useState<any>('blue');
  const [color2,setColor2] = useState<any>('blue');
  const [color3,setColor3] = useState<any>('blue');

  //get the location on load
 
  useIonViewDidEnter(() => {
    //setGroupColor(colorpin);
    console.log("willenter - title:",projtitle);
    loadMarkers();
  });

 function loadMarkers(){
   console.log("load");
      get("project1")
      .then(function (finalResult) { //get the user data to authenticate the user
        const userD = JSON.parse(finalResult);
        if(finalResult !== null){
          var savetitle = userD.Title.replace(/ /g,"_");
          get(savetitle)
          .then(function (finalResult) { //get the user data to authenticate the user
            const loadedMarkers1 = JSON.parse(finalResult);
            var loadedColor = loadedMarkers1.markers[0].color;
            setColor1(loadedColor);
            console.log("c1",color1);
            setMyMarkers(loadedMarkers1.markers);
            
          }).catch(err => {//unable to load the local storage
            console.log("e: " + err.message);
          }
          );
        }
      }).catch(err => {//unable to load the local storage
          console.log("e: " + err.message);
      });

      get("project2")
      .then(function (finalResult) { //get the user data to authenticate the user
        const userD = JSON.parse(finalResult);
        if(finalResult !== null){
          var savetitle = userD.Title.replace(/ /g,"_");
          get(savetitle)
        .then(function (finalResult) { //get the user data to authenticate the user
          
          const loadedMarkers2 = JSON.parse(finalResult);
          var loadedColor = loadedMarkers2.markers[0].color;
          setColor2(loadedColor);
          setMyMarkers2(loadedMarkers2.markers);
        }).catch(err => {//unable to load the local storage
          console.log("e: " + err.message);
        }
        );
        }
      }).catch(err => {//unable to load the local storage
          console.log("e: " + err.message);
      });

  get("project3")
  .then(function (finalResult) { //get the user data to authenticate the user
     const userD = JSON.parse(finalResult);
     if(finalResult !== null){
      var savetitle = userD.Title.replace(/ /g,"_");
      get(savetitle)
    .then(function (finalResult) { 
       const loadedMarkers3 = JSON.parse(finalResult);
       setMyMarkers3(loadedMarkers3.markers);
       var loadedColor = loadedMarkers3.markers[0].color;
      setColor3(loadedColor);
      }).catch(err => {//unable to load the local storage
        console.log("e: " + err.message);
      }
      );
      }
  }).catch(err => {//unable to load the local storage
      console.log("e: " + err.message);
  });
 }

  function setMapCenter(lat:any, long:any){
    setCenter([lat,long]);
  }
  /*don't need this*/
  function updateMarkers(e:any){
      if(e !== ""){
        setMarkers(e);
      }
  }


  //debug stuff
  useEffect(() => {
    console.log(markers);
  }, [markers]);
  useEffect(() => {
    console.log(group);
  }, [group]);

  useEffect(() => {
    console.log("center updated",mapCenter);
  }, [mapCenter]);

  useEffect(() => {
    console.log(myMarkers);
  },[myMarkers]);
  useEffect(() => {
    console.log(myMarkers2);
  },[myMarkers2]);
  useEffect(() => {
    console.log(myMarkers3);
  },[myMarkers3]);

    return (
      <>
      <IonToast
          isOpen={error.showError}
          onDidDismiss={() => setError({ message: "", showError: false })}
          message={error.message}
          duration={3000}
      />
      <IonLoading
          isOpen={loading}
          onDidDismiss={() => setLoading(false)}
          message={'Saving Markers...'}
      />
      <IonPage>
        <LoginCheck/>
        <IonHeader translucent={true} >
        <IonToolbar>
        <IonButton size="small" slot="start" color="primary" onClick={() => history.replace("/explore/")} className="back"><IonIcon slot="start" icon={chevronBackOutline}/>Back</IonButton>
        <IonButton size="small" slot="end" color="primary" onClick={() => logOut()}  className="logout"><IonIcon slot="end" icon={logOutOutline}/>Log Out</IonButton>
        </IonToolbar>
      </IonHeader>
      
          <IonContent className="ion-text-center maintext headerimage">
            <IonText className="plantext2 innertext">
      <span>[</span>  <h3>Explore</h3> <span>]</span><h5>View Saved Explorations</h5></IonText>
              <IonGrid className="grid">
              <IonRow>
                <IonText class="browntext">Select the layer tool to display explorations</IonText>
                  <MapGroup
                      listOfMarkers={myMarkers}
                      listOfMarkers2={myMarkers2}
                      listOfMarkers3={myMarkers3}
                      mapCenter={mapCenter}
                      loadMarkers={loadMarkers}
                      updateMarkers={updateMarkers}
                      setMapCenter={setMapCenter}
                      color1={color1}
                      color2={color2}
                      color3={color3}
                  />
              </IonRow>
              </IonGrid>
        </IonContent>
      
        <FooterComponent/>
      </IonPage>
      </>
    );
  };


export default ViewExploration;